import { render, staticRenderFns } from "./PrintTransactionSandogh.vue?vue&type=template&id=06cfaed0&scoped=true&"
import script from "./PrintTransactionSandogh.vue?vue&type=script&lang=js&"
export * from "./PrintTransactionSandogh.vue?vue&type=script&lang=js&"
import style0 from "./PrintTransactionSandogh.vue?vue&type=style&index=0&id=06cfaed0&scoped=true&lang=css&"
import style1 from "./PrintTransactionSandogh.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cfaed0",
  null
  
)

export default component.exports